import BatterTableDataView from "@/components/BatterTableDataView.vue";
export default {
  name: "MobileUserListView",
  components: {
    BatterTableDataView
  }
};